// extracted by mini-css-extract-plugin
module.exports = {"block__direction":"_15F9De","darkFont":"_2GWk9u mz-default-dark-font","title":"_32wvpB","route":"_2hZtb6","mobile":"_1pKMBA"};